/**
 * author andre.pitombeira
 */
'use strict';
import './vendor/ec-fe-bo-template/dist/views/schema/schema.html';
import './vendor/ec-fe-bo-template/dist/views/schema/schema.header.html';
import './vendor/ec-fe-bo-template/dist/views/schema/schemas.html';
import './vendor/ec-fe-bo-template/dist/views/partials/aside.html';

import baseTpl from './vendor/ec-fe-bo-template/dist/views/base/template.html';
import authTpl from 'app/vendor/ec-fe-bo-template/dist/views/base/access.html';
import signinTpl from './common/signin/signin.html';
import dashboardTpl from './common/dashboard/dashboard.html';
import websiteServicesTpl from './common/academy/website-services.html';

export default function appRouter($stateProvider, $urlRouterProvider, $locationProvider) {
  $urlRouterProvider.otherwise('/app/dashboard');
  $locationProvider.hashPrefix('');
  $stateProvider
    .state('app', {
      abstract: true,
      url: '/app',
      templateUrl: baseTpl,
      resolve: {
        authenticated: [
          '$injector',
          function($injector) {
            var AuthenticationService = $injector.get('AuthenticationService');
            return AuthenticationService.checkAuthentication();
          },
        ],
      },
    })
    .state('app.dashboard', {
      url: '/dashboard',
      templateUrl: dashboardTpl,
    })
    .state('auth', {
      url: '/auth',
      templateUrl: authTpl,
    })
    .state('auth.signin', {
      url: '/signin',
      templateUrl: signinTpl,
      controller: 'SigninController as signin',
    })
    .state('auth.signout', {
      url: '/signout',
      resolve: {
        authorize: [
          '$injector',
          '$window',
          '$state',
          'sessionService',
          function($injector, $window, $state, sessionService) {
            var AuthenticationService = $injector.get('AuthenticationService');
            var timeOut = $injector.get('$timeout');
            return AuthenticationService.signout().finally(function() {
              sessionService.destroySession();
              timeOut(() => {
                $state.go('auth.signin');
              }, 100);
            });
          },
        ],
      },
    })
    .state('app.academy_website_services', {
      url: '/academy/website_services',
      templateUrl: websiteServicesTpl,
    });
}



// WEBPACK FOOTER //
// ./src/app/app.router.js